module.exports = __webpack_public_path__ + "img/vpc100.bd9a755.png";